export enum CreferenceMode {
  Pill = "pill",
  Inline = "inline",
}
